import { Download, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const ProductPdfPreview = ({ product, onDownload }) => {
  if (!product.pdf) return null;
  return (
    <section className="py-16 md:py-20 bg-parchment/40">
      <div className="container mx-auto">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
          <div>
            <div className="font-script text-2xl text-leaf">the full sell sheet</div>
            <h2 className="font-display text-3xl sm:text-4xl text-primary font-medium mt-1 leading-tight">
              Printable 8.5" × 11" PDF preview
            </h2>
          </div>
          <div className="flex gap-3">
            <Button onClick={onDownload} className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90 px-5 h-11">
              <Download className="mr-1.5 h-4 w-4" /> Download PDF
            </Button>
            <Button asChild variant="outline" className="rounded-full border-primary/25 text-primary hover:bg-secondary px-5 h-11">
              <a href={product.pdf} target="_blank" rel="noopener noreferrer">
                Open in new tab <ExternalLink className="ml-1.5 h-4 w-4" />
              </a>
            </Button>
          </div>
        </div>
        <div className="max-w-md mx-auto rounded-3xl overflow-hidden border border-border/70 bg-card shadow-card">
          <a
            href={product.pdf}
            target="_blank"
            rel="noopener noreferrer"
            className="group block relative bg-secondary"
            aria-label={`${product.name} sell sheet (opens PDF in a new tab)`}
          >
            <img
              src={`/sell-sheets/${product.slug}.jpg`}
              alt={`${product.name} sell sheet preview`}
              className="w-full h-auto block group-hover:opacity-95 transition-opacity"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/5 transition-colors" />
            <div className="absolute bottom-4 right-4 inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-background/95 backdrop-blur text-xs font-medium text-primary shadow-pop opacity-0 group-hover:opacity-100 transition-opacity">
              Open PDF <ExternalLink className="h-3.5 w-3.5" />
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ProductPdfPreview;
